export function getFocusedElement(): Element | None {
  if (
    import.meta.client &&
      document.hasFocus() &&
      document.activeElement !== document.body &&
      document.activeElement !== document.documentElement
  ) {
    return document.activeElement
  }
}
